export default {
    namespaced: true,
    state: {
        show: false,
        message: 'Error'
    },
    getters: {
    },
    mutations: {
        setShow( state, data ) {
            state.show = data;
        },
        setMessage( state, data ) {
            state.message = data;
        }
    },
    actions : {
        toggle( context, payload ) {
            context.commit( 'setShow', !context.state.show );
        },
        show( context, payload ) {
            if ( payload !== null ) {
                context.commit( 'setMessage', payload );
            }
            context.commit( 'setShow', true );
        },
        hide( context, payload ) {
            context.commit( 'setShow', false );
        }
    }
}